<template>
  <div v-if="dataLoaded">

    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push(`/etim`)"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-6">
        <q-btn  style="float: right"
          class="capitalize ctrl-button right q-ml-md"
          :color="'ctrl-turquoise'"
          :label="`${$store.state.stringsStore.strings.action.save}`"
          @click="saveChanges()"
          icon-right="save"
        />
        <q-btn v-if="data.id"
          class="q-ml-md capitalize ctrl-button right"
          icon-right="delete"
          color="negative capitalize"
          :label="$store.state.stringsStore.strings.action.delete"
          @click="deleteCategory()"
          align="right"
        />
      </div>
    </div>

    <div class="row gutter-sm q-mb-lg">
      <!-- General Information -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <p class="card-title">
          {{ getString('category') }}
        </p>
        <div class="card-block">
          <!-- Name -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.name"

              :float-label="getString('name')">
            </q-input>
          </q-field>
          <!-- Description -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.description"

              :float-label="getString('description')">
            </q-input>
          </q-field>
          <!-- Sort id -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.sort_id"

              :float-label="getString('module.etim.category.properties.sortorder')">
            </q-input>
          </q-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import fetchDetail from '@/mixins/detailViews/fetchDetail';
import saveChanges from '@/mixins/detailViews/saveChanges';
import getString from '@/helpers/GetStrings';
import common from '../common';

export default {
  data() {
    return {
      successMessage: getString('module.etim.category.edit.save.success'),
      dataLoaded: false,
    };
  },
  mixins: [
    fetchDetail,
    saveChanges,
    common,
  ],
  methods: {
    getString,

    deleteCategory() {
      // Dialog
      this.$q.dialog({
        title: '',
        message: this.getString('module.library.delete.title.single'),
        ok: this.$store.state.stringsStore.strings.dialog.confirm.ok,
        cancel: this.$store.state.stringsStore.strings.dialog.confirm.cancel,
      }).then(() => {
        // delete call
        this.axios.delete(`etim/category/${this.data.id}`)
          .then(() => {
            // Refresh data to see the result
            this.$q.notify({
              message: this.getString('upload.delete.success').replace('%file%', this.getString('category')),
              position: 'top-right',
              timeout: 1000,
              color: 'positive',
            });
            this.$router.push('/etim');
          })
          .catch((error) => {
            // Error
            console.warn(error);
          });
      }).catch(() => {
        console.warn('Not removed');
      });
    },

    requestParams() {
      return {
        name: this.data.name,
        description: this.data.description,
        sort_id: this.data.sort_id,
      };
    },

    toggle(value, param) {
      this.axios.put(`${this.endpoint}/${this.data.id}`, qs.stringify({ [param]: value ? 1 : 0 }));
    },
  },
  filters: {
    checkEmpty(value) {
      return value === null || value === '' ? '-' : value;
    },
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>


<style lang="stylus" scoped>
@import '~variables';
.data-title
  font-weight 700

.data-content
  word-break break-all

</style>
